const faviconsContext = require.context(
  '!!file-loader?name=./favicons/[name].[ext]!.',
  true,
  /\.(svg|png|ico|xml)$/
);
faviconsContext.keys().forEach(faviconsContext);

require('~/favicons/manifest.json');
